// spiderVeinsData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[] | any;
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const spiderVeins: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Best Spider Veins Treatment in Dubai | Effective Vein Removal",
            "description": "Professional spider veins treatment in Dubai using advanced techniques to reduce visibility of unsightly veins. Book your consultation today for smoother skin.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/spider-veins-treatment/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Best Spider Veins Treatment in Dubai | Effective Vein Removal",
                "description": "Professional spider veins treatment in Dubai using advanced techniques to reduce visibility of unsightly veins. Book your consultation today for smoother skin.",
                "url": "https://elitebodyhome.com/services/spider-veins-treatment/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Spider Veins Treatment Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Best Spider Veins Treatment in Dubai | Effective Vein Removal",
                "description": "Professional spider veins treatment in Dubai using advanced techniques to reduce visibility of unsightly veins. Book your consultation today for smoother skin.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Spider Veins Treatment"],
        "hero": {
            "title": "Spider Veins Treatment",
            "subtitle": "",
            "description": "Spider veins, with its medical term as telangiectasias, are small, weakened veins that show close to the surface of the skin. They're typically thin, red or blue-thread veins that appear on your leg or face. Although they're harmless, spider veins can be painful and make you feel self-conscious. Lucky for you, there are treatments that are proven to help eliminate or reduce the appearance of spider veins."
        },
        "howItWorks": {
            "title": "Spider Veins Treatment Procedure",
            "description": "The treatment of spider veins focuses on improving the appearance of affected areas and enhancing overall skin smoothness."
        },
        "procedureSteps": {
            "heading": "Our Spider Veins Treatments",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Discussion of customized solutions based on severity, location and type of spider veins for optimal results",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "Radiofrequency Ablation",
                    "desc": "Uses radiofrequency energy to close off veins, improving circulation and reducing spider vein appearance",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Short Recovery",
                    "desc": "Most procedures are performed with minimal downtime, allowing quick return to daily activities",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Post-Treatment Support",
                    "desc": "Comprehensive follow-up and personalized aftercare ensures lasting results and vascular health",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Spider Veins Treatment",
            "subheading": "",
            "para": "Spider veins treatment not only has great cosmetic value but can also result in pain relief, as it will restore the look of your skin.",
            "items": [
                {
                    "title": "Improved Appearance",
                    "desc": "One of the most visible returns is the elimination or decrease of the appearance of spider veins for clearer and smoother skin",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Enhanced Comfort",
                    "desc": "Spider veins may ache, burn or throb. By easing these symptoms, the therapy significantly increases comfort",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Boosted Confidence",
                    "desc": "Many people also feel more confident after treatment for they no longer need to cover unsightly veins",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Minimally Invasive Options",
                    "desc": "Thanks to treatments such as sclerotherapy and laser therapy, spider veins can be treated with little downtime and pain",
                    "icon": "fa-solid fa-hand-holding-medical"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Spider Vein Treatment Candidates While everyone is a little different no everyone is the best candidate for spider vein treatment. Suitability is mostly determined by the extent of the problem, general health, and patient preference.",
            "items": [
                {
                    "title": "Generally Healthy",
                    "desc": "You are generally healthy with no significant medical problems",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "Visible Spider Veins",
                    "desc": "You have prominent 'spider veins' on your legs, face, or other site",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Aesthetic Concerns",
                    "desc": "You are looking for an aesthetic treatment that can help to reduce the appearance of veins you can see",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "Pain or Discomfort",
                    "desc": "Sensation of pain or discomfort due to spider veins inhibiting activities of daily living",
                    "icon": "fa-solid fa-hand-holding-medical"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Adequate preparation can make the treatment for spider vein problems a smooth and successful one. It is important that patients adhere to the pre-treatment advice to reduce any risks and achieve the very best results.",
            "items": [
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Too much sun exposure can make the skin worse and interferes with the healing. You should avoid tanning beds and use sunscreen prior to treatment",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Stop Certain Medications",
                    "desc": "Some medications — including blood thinners and anti-inflammatory drugs — need to be stopped before treatment to minimize bruising or bleeding",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Hydrated skin is more elastic and recovers better, so drink some water before your appointment!",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Wear Loose Clothing",
                    "desc": "Wear loose clothing on the day of treatment which can be taken off or moved easily to expose the treatment area",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Compression Stockings",
                    "desc": "Your doctor may advise purchasing compression stockings ahead of time, depending on the type of treatment you will receive",
                    "icon": "fa-solid fa-socks"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Treatment of spider veins not only offers highly visible results, but also has a minimal recovery time, so that patients may enjoy smoother, veinless skin.",
            "items": [
                {
                    "title": "Visible Improvements",
                    "desc": "Spider veins typically resolve within a few weeks after treatment. Complete results may not be seen for 3-6 months and varies by severity of veins and treatment method",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Minimal Downtime",
                    "desc": "Most patients are able to return to their normal activities in 24-48 hours, but compression stockings will need to be worn for a few days following the procedure",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Long-lasting Effects",
                    "desc": "After treatment, spider veins usually do not reappear. But some lifestyle changes can prevent new spider veins from developing",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "What causes spider veins?",
                    "answer": "Spider veins can be caused by factors such as aging, hormonal changes, genetics, pregnancy, and prolonged standing or sitting. Over time, veins weaken, leading to the development of spider veins."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "Most patients experience minimal discomfort during spider vein treatments. Sclerotherapy may cause mild burning or stinging during the injection, while laser therapy may cause a slight tingling sensation. Anesthesia is not usually necessary."
                },
                {
                    "question": "How long does recovery take?",
                    "answer": "Recovery time is generally short. Patients can typically return to normal activities within a day or two after treatment. However, strenuous activities and prolonged sun exposure should be avoided for several weeks."
                },
                {
                    "question": "How many sessions are required?",
                    "answer": "The number of sessions depends on the size and number of veins being treated. Most people require between 1-3 sessions for optimal results."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-2-scaled.jpg",
            "beforeAfter": [
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Spider-Veins-Treatment-in-dubai-3.jpg", "alt": "spider veins treatment" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Spider-Veins-Treatment-in-dubai-2.jpg", "alt": "spider veins removal" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Spider-Veins-Treatment-in-dubai-1.jpg", "alt": "vein treatment" }
            ]
        },
        "product": {
            "id": 314,
            "title": "Spider Veins Treatment Package",
            "price": 899,
            "description": "Comprehensive spider veins treatment package including consultation, treatment sessions, and follow-up care. Our expert team offers effective vein reduction solutions."
        }
    },
    "ar": {
        "url": "",
        "meta": {
            "title": "أفضل علاج للأوردة العنكبوتية في دبي | إزالة الأوردة الظاهرة",
            "description": "علاج احترافي للأوردة العنكبوتية في دبي باستخدام تقنيات متطورة لتقليل ظهور الأوردة غير المرغوب فيها. احجز استشارتك اليوم للحصول على بشرة أكثر نعومة.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/ar/services/spider-veins-treatment/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "أفضل علاج للأوردة العنكبوتية في دبي | إزالة الأوردة الظاهرة",
                "description": "علاج احترافي للأوردة العنكبوتية في دبي باستخدام تقنيات متطورة لتقليل ظهور الأوردة غير المرغوب فيها. احجز استشارتك اليوم للحصول على بشرة أكثر نعومة.",
                "url": "https://elitebodyhome.com/ar/services/spider-veins-treatment/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "علاج الأوردة العنكبوتية دبي",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "أفضل علاج للأوردة العنكبوتية في دبي | إزالة الأوردة الظاهرة",
                "description": "علاج احترافي للأوردة العنكبوتية في دبي باستخدام تقنيات متطورة لتقليل ظهور الأوردة غير المرغوب فيها. احجز استشارتك اليوم للحصول على بشرة أكثر نعومة.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "علاج الأوردة العنكبوتية"],
        "hero": {
            "title": "علاج الأوردة العنكبوتية",
            "subtitle": "",
            "description": "تعرف الأوردة العنكبوتية طبيًا باسم توسع الشعيرات، وهي أوعية دموية صغيرة وضعيفة تظهر بالقرب من سطح الجلد على شكل خطوط دقيقة حمراء أو زرقاء على الساقين أو الوجه. رغم أنها ليست خطيرة، إلا أنها قد تسبب بعض الألم وتؤثر على ثقتك بنفسك. لحسن الحظ، توجد تقنيات علاج مثبتة تساعد على إزالة أو تقليل ظهور الأوردة العنكبوتية بفاعلية."
        },
        "howItWorks": {
            "title": "إجراء علاج الأوردة العنكبوتية",
            "description": "يركز علاج الأوردة العنكبوتية على تحسين مظهر المناطق المصابة وتعزيز نعومة البشرة بشكل عام."
        },
        "procedureSteps": {
            "heading": "علاجات الأوردة العنكبوتية المتوفرة لدينا",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "تُناقش الحلول المخصصة المتوفرة ويعتمد تحديد العلاج المناسب على شدة الأوردة العنكبوتية، وموقعها، ونوعها لضمان أفضل النتائج.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "استئصال بالراديو فريكونسي",
                    "desc": "يستخدم طاقة التردد الراديوي لإغلاق الأوردة، مما يحسن الدورة الدموية ويقلل من ظهور الأوردة العنكبوتية.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "فترة تعافي قصيرة",
                    "desc": "تُجرى معظم الإجراءات مع فترة تعافي قصيرة، مما يسمح لك بالعودة إلى نشاطاتك اليومية سريعًا.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "الدعم بعد العلاج",
                    "desc": "نوفر متابعة شاملة ورعاية شخصية بعد العلاج لضمان نتائج دائمة وصحة الأوعية الدموية.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد علاج الأوردة العنكبوتية",
            "subheading": "",
            "para": "لا يقتصر علاج الأوردة العنكبوتية على تحسين المظهر فقط، بل يمكن أن يخفف أيضًا من الألم ويُعيد لبشرتك مظهرها الطبيعي.",
            "items": [
                {
                    "title": "تحسين المظهر",
                    "desc": "تُعد من أبرز النتائج إزالة أو تقليل ظهور الأوردة العنكبوتية، مما يجعل البشرة أكثر صفاءً ونعومة.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "زيادة الراحة",
                    "desc": "قد تسبب الأوردة العنكبوتية ألمًا أو حرقانًا أو نبضًا، ويساعد العلاج في تخفيف هذه الأعراض، خصوصًا عند الوقوف أو الجلوس لفترات طويلة.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يشعر الكثيرون بثقة أكبر بعد العلاج، حيث لم يعودوا مضطرين لارتداء ملابس طويلة أو جوارب لتغطية الأوردة غير المرغوبة.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "خيارات علاجية غير جراحية",
                    "desc": "يمكن علاج دوالي العنكبوت بسهولة مع فترة تعافي قصيرة وألم محدود بفضل التقنيات الحديثة مثل العلاج بالتصليب والليزر.",
                    "icon": "fa-solid fa-hand-holding-medical"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "لا يناسب العلاج لجميع الحالات لاختلاف كل حالة عن الأخرى. تُحدد مدى ملاءمة العلاج بناءً على عدة عوامل، من بينها شدة الحالة، والحالة الصحية العامة، وتفضيلات المريض.",
            "items": [
                {
                    "title": "صحة عامة جيدة",
                    "desc": "إذا كنت تتمتع بصحة عامة جيدة ولا تعاني من مشكلات صحية خطيرة.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "أوردة عنكبوتية واضحة",
                    "desc": "إذا كنت تعاني من أوردة عنكبوتية واضحة في الساقين أو الوجه أو في مناطق أخرى من الجسم.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "اهتمامات تجميلية",
                    "desc": "إذا كنت تبحث عن حل تجميلي لتقليل مظهر الأوردة الواضح على الجلد.",
                    "icon": "fa-solid fa-palette"
                },
                {
                    "title": "ألم أو انزعاج",
                    "desc": "إذا كنت تعاني من انزعاج أو ألم نتيجة الأوردة العنكبوتية يؤثر على أنشطتك اليومية.",
                    "icon": "fa-solid fa-hand-holding-medical"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يساهم التحضير الجيد بشكل كبير في نجاح العلاج وسلاسته. يجب الالتزام بالإرشادات المسبقة لتقليل أي مضاعفات وضمان الحصول على أفضل النتائج.",
            "items": [
                {
                    "title": "تجنب التعرض لأشعة الشمس",
                    "desc": "قد يؤدي التعرض المفرط لأشعة الشمس إلى تفاقم الحالة الجلدية ويؤثر سلبًا على عملية الشفاء. يُنصح بتجنب أجهزة تسمير البشرة واستخدام واقي شمس مناسب قبل العلاج.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "إيقاف بعض الأدوية",
                    "desc": "قد يُطلب منك التوقف عن تناول بعض الأدوية، مثل مميعات الدم ومضادات الالتهاب، قبل الجلسة لتقليل احتمالية حدوث كدمات أو نزيف. سيقوم الطبيب بتزويدك بتعليمات دقيقة حسب حالتك.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الحفاظ على ترطيب جسمك",
                    "desc": "يساعد الحفاظ على الترطيب في التعافي بشكل أفضل، لذا احرص على شرب كمية كافية من الماء قبل الموعد.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "ارتداء ملابس مريحة وفضفاضة",
                    "desc": "يُفضل ارتداء ملابس واسعة في يوم العلاج ليسهل الوصول إلى المنطقة المعالجة دون تقييد أو انزعاج.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "جوارب ضاغطة",
                    "desc": "قد يوصي الطبيب باستخدام جوارب ضاغطة بعد الجلسة حسب نوع العلاج المُختار، للمساعدة في تعزيز الدورة الدموية وتسريع الشفاء.",
                    "icon": "fa-solid fa-socks"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "لا يقدم علاج الأوردة العنكبوتية نتائج واضحة وملموسة فقط، بل يتميز أيضًا بفترة تعافي قصيرة، مما يتيح للمرضى التمتع ببشرة أكثر نعومة وخالية من الأوردة الظاهرة.",
            "items": [
                {
                    "title": "تحسن واضح",
                    "desc": "تبدأ الأوردة العنكبوتية بالاختفاء خلال بضعة أسابيع من الجلسة، لكن قد تستغرق النتائج الكاملة من 3 إلى 6 أشهر لتظهر بشكل نهائي، ويعتمد ذلك على شدة الحالة ونوع العلاج المستخدم.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "فترة تعافي قصيرة",
                    "desc": "يتمكن معظم المرضى من العودة إلى أنشطتهم اليومية خلال 24 إلى 48 ساعة فقط بعد الإجراء. ومع ذلك، يُنصح بارتداء الجوارب الضاغطة لعدة أيام بعد العلاج لدعم الشفاء وتعزيز النتائج.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "لا تظهر الأوردة المعالجة مجددًا، لكن يُنصح باتباع نمط حياة صحي يشمل الحفاظ على وزن مثالي، وممارسة النشاط البدني بانتظام، وتجنب الوقوف أو الجلوس لفترات طويلة دون حركة للحفاظ على النتائج ومنع ظهور أوعية جديدة.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "",
            "items": [
                {
                    "question": "ما الذي يسبب ظهور الأوردة العنكبوتية؟",
                    "answer": "تظهر الأوردة العنكبوتية نتيجة عدة عوامل، منها التقدم في العمر، والتغيرات الهرمونية، والعوامل الوراثية، والحمل، والوقوف أو الجلوس لفترات طويلة. ومع مرور الوقت، تضعف جدران الأوردة وتفقد كفاءتها، مما يؤدي إلى تمددها وظهورها بوضوح على سطح الجلد."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "لا يشعر معظم المرضى إلا بانزعاج بسيط أثناء العلاج. قد يُسبب العلاج بالتصليب شعورًا خفيفًا بالحرقة أو الوخز أثناء الحقن، أما العلاج بالليزر فقد ينتج عنه شعور بالوخز أو الدفء دون الحاجة إلى تخدير عادةً."
                },
                {
                    "question": "كم يستغرق التعافي؟",
                    "answer": "تكون مدة التعافي قصيرة في الغالب. يمكن للمرضى العودة إلى أنشطتهم اليومية خلال 24 إلى 48 ساعة من العلاج. ومع ذلك، يُنصح بتجنب التمارين الشاقة والتعرض المباشر لأشعة الشمس لعدة أسابيع بعد الجلسة."
                },
                {
                    "question": "كم عدد الجلسات المطلوبة؟",
                    "answer": "يعتمد عدد الجلسات على حجم وعدد الأوردة المعالجة. غالبًا ما يحتاج المريض من جلسة واحدة إلى ثلاث جلسات للحصول على نتائج مثالية."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }
}
